import React from 'react'
import createClass from 'create-react-class'
import PropTypes from 'prop-types'
import Select from 'react-select'
import 'react-select/dist/react-select.css'

const CreatableSelect = createClass({
  propTypes: {
    creatable: PropTypes.bool,
    disabled: PropTypes.bool,
    multi: PropTypes.bool,
    valueKey: PropTypes.string.isRequired,
    labelKey: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    placeholder: PropTypes.string,
    options: PropTypes.array,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
      PropTypes.object,
    ]),
    valueChangeFunction: PropTypes.func.isRequired
  },
  getInitialState() {
    return {
      inputValue: ''
    }
  },
  handleOnChange (value) {
    this.setState({ inputValue: '' })
    this.props.valueChangeFunction(value)
  },
  handleInputChange(inputValue) {
    this.setState({ inputValue })
    return inputValue
  },
  handleBlur() {
    if (this.state.inputValue && this.props.multi && this.props.creatable) {
      const newValue = this.state.inputValue.trim()
      if (newValue) {
        const currentValues = Array.isArray(this.props.value) ? this.props.value : []
        const valueKey = this.props.valueKey
        const newItem = { [valueKey]: newValue }
        this.props.valueChangeFunction([...currentValues, newItem])
        this.setState({ inputValue: '' })
      }
    }
  },
  renderLabel() {
    if (this.props.label) {
      return typeof this.props.label === 'string' ? <h5 className="section-heading">{this.props.label}</h5> : this.props.label
    }
  },
  render () {
    const SelectComponent = this.props.creatable ? Select.Creatable : Select
    const options = this.props.options ? this.props.options.map(a => Object.assign({}, a)) : []
    return (
      <div className="section">
        {this.renderLabel()}
        <SelectComponent
          labelKey={this.props.labelKey || 'name'}
          placeholder={this.props.placeholder || 'Select...'}
          valueKey={this.props.valueKey}
          multi={this.props.multi || false}
          disabled={this.props.disabled || false}
          options={options}
          onChange={this.handleOnChange}
          onInputChange={this.props.creatable ? this.handleInputChange : undefined}
          onBlur={this.props.creatable ? this.handleBlur : undefined}
          inputValue={this.state.inputValue}
          value={this.props.value}
          promptTextCreator={(label) => `Create "${label}"`}
        />
      </div>
    )
  }
})

export default CreatableSelect



// WEBPACK FOOTER //
// ./src/components/Wps/CreatableSelect.js